import { Injectable } from '@angular/core';

import { Http, Headers, Response, RequestOptions,  } from '@angular/http';
import { UserData } from './user-data';
import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";
import { Events } from 'ionic-angular';
@Injectable()
export class TasksData {
  data: any;
  added_ids: any;

  constructor(public http: Http, public common: CommonData, public userData: UserData, public events: Events) {
    this.added_ids = [];
  }
  clear(){
    if(this.data!=null){
      this.data.length = 0;
    }
  }
  load() {
    /*
    if (this.data) {
      return Promise.resolve(this.data);
    }
    */
    // don't have the data yet
    return new Promise(resolve => {
      if(this.userData.loggedin){

        this.http.get(this.common.baseurl+'tasks/index?token='+this.userData.jwt).subscribe(res => {
          // we've got back the raw data, now generate the core schedule data
          // and save the data for later reference
          //this.data = this.processData(res.json());
          this.data = res.json().data;
          resolve("");
        }, error => {
          console.log('HTTP Error, no answer');
          console.log(error);
      });

      }
    });
  }

  takscount(){
    this.http.get(this.common.baseurl+'tasks/count?token='+this.userData.jwt).subscribe(res => {
      // we've got back the raw data, now generate the core schedule data
      // and save the data for later reference
      //this.data = this.processData(res.json());
      //this.data = res.json().data;
      //console.log(res.json().data.taskcount)
      this.events.publish('updatecounter', "Tasks" ,res.json().data.taskcount);  

    }, error => {
      console.log('HTTP Error, no answer');
      console.log(error);
  });    
  }


  view(task_id) {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        let params = JSON.stringify({ 
          id: task_id
          ,token: this.userData.jwt
        });            

        this.http.post(this.common.baseurl+'tasks/view',params).subscribe(res => {
          let data = res.json().data;
          resolve(data);
        }, error => {
          console.log('HTTP Error, no answer');
          //console.log(error);
      });

      }
    });
  }  



  create(task) {
    return new Promise(resolve => {
      //console.log(pbzone);
      let params = JSON.stringify({ 
        task: task
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'tasks/create',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){   
              this.added_ids.push(response.data.id);
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });   
  }    
  update(task) {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        let params = JSON.stringify({ 
          id: task.id
          ,task: task
          ,token: this.userData.jwt
        });            

        this.http.post(this.common.baseurl+'tasks/update',params).subscribe(res => {
          let data = res.json();
          //console.log(data);
          this.takscount();
          resolve(data);
        }, error => {
          console.log('HTTP Error, no answer');
          //console.log(error);
      });

      }
    });

  }    
  delete(task_id) {
    return new Promise(resolve => {
    });

  }    

}



// WEBPACK FOOTER //
// ./src/providers/tasks-data.ts